import React, { useState } from 'react'
import { Outlet } from 'react-router-dom'
import Header from '../components/Layout/Header'
import SidebarMenu from '../components/Layout/SidebarMenu'
import DynamicSidebarMenu from '../components/Layout/SidebarMenu/DynamicSidebarMenu'
import Footer from '../components/Layout/Footer'

const DashboardLayout: React.FC = () => {
  const [isSidebarActive, setIsSidebarActive] = useState(false)

  const toggleSidebar = () => {
    setIsSidebarActive(!isSidebarActive)
    const mainContentWrap = document.querySelector('.main-content-wrap')
    if (mainContentWrap) {
      mainContentWrap.classList.toggle('active', !isSidebarActive)
    }
  }

  return (
    <div className={`main-content-wrap ${isSidebarActive ? 'active' : ''}`}>
      <DynamicSidebarMenu toggleActive={toggleSidebar} />
      <div className="main-content">
        <Header toggleActive={toggleSidebar} />
        <Outlet />
        <Footer />
      </div>
    </div>
  )
}

export default DashboardLayout

